export class Base64 {
    constructor() { }

    decode(encodedMessage): any {
        return atob(encodedMessage);
    }
}
